/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_Help_Articles_DescriptionInputs */



/**
* | output |
* | --- |
* | "How everything on the site works" |
*
* @param {Layout_Header_Help_Articles_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_help_articles_description = /** @type {((inputs?: Layout_Header_Help_Articles_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_Help_Articles_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wie alles auf der Seite funktioniert")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comment tout fonctionne sur le site")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("站内各项功能的用法")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("站上各項功能的使用方式")
	if (locale === "ko") return /** @type {LocalizedString} */ ("사이트의 모든 기능 사용법")
	return /** @type {LocalizedString} */ ("How everything on the site works")
});